module.exports = __webpack_public_path__ + "img/solar-system.0e922044.svg";